<script setup lang="ts">
// Vue & Plugins
import { ref } from 'vue'

// Models
import { ColumnNode } from 'primevue/column'
import { SiteID } from '../../../sites/models/site'
import { Shift } from '../../../shifts/models/shift'
import { EmployeeShiftOffer } from '../../../employee_shift/models/employeeShiftOffer'
import ShiftOfferTableRow from './ShiftOfferTableRow.vue'
import ShiftOfferStatusBadge from '../../../shifts/components/badges/ShiftOfferStatusBadge.vue'

const OFFER_COLUMNS = {
  EMPLOYEE: {
    field: 'employee',
    header: 'Employee',
    headerClass: '',
    bodyClass: '',
  },
  STATUS: {
    field: 'offerStatus',
    header: 'Status',
    headerClass: '',
    bodyClass: '',
  },
  CHECK_IN: {
    field: 'checkIn',
    header: 'Check-In',
    headerClass: '',
    bodyClass: '',
  },
  ACTIONS: {
    field: 'actions',
    header: 'Actions',
    headerClass: '',
    bodyClass: '',
  },
} as const

const { siteId, shift, offers } = defineProps<{
  siteId: SiteID
  shift: Shift
  offers: EmployeeShiftOffer[]
}>()

const columns = ref([
  OFFER_COLUMNS.EMPLOYEE,
  OFFER_COLUMNS.STATUS,
  OFFER_COLUMNS.CHECK_IN,
  OFFER_COLUMNS.ACTIONS,
])
</script>

<template>
  <DataTable
    :value="offers"
    row-group-mode="subheader"
    group-rows-by="status"
    :show-headers="false"
  >
    <template #groupheader="{ data }">
      <div class="inline-flex items-center gap-x-4">
        <div class="flex gap-x-2">
          <ShiftOfferStatusBadge
            :status="data.status"
          />
        </div>
      </div>
    </template>
    <Column field="status" header="Status"></Column>
    <Column
      v-for="column in columns"
      :key="column.field"
      :field="column.field"
      :header="column.header"
      :header-class="column.headerClass"
      :body-class="column.bodyClass"
    >
      <template
        #body="{
          data,
          field,
        }: {
          data: EmployeeShiftOffer
          node: any
          column: ColumnNode
          field: string | ((item: EmployeeShiftOffer) => string) | undefined
          index: number
          frozenRow: boolean
        }"
      >
        <ShiftOfferTableRow
          :site-id="siteId"
          :shift="shift"
          :offer="data"
          :field="field as string"
        />
      </template>
    </Column>
  </DataTable>
</template>
